module.exports = __webpack_public_path__ + "static/media/LG-G5.97acc71e.jpg";